// Touch screens keep :hover/:active on the last tapped element, so a single tap paused a marquee
// for good on iPhone. Pause marquees on hover and click only where there is a real pointer.
export const canHoverWithPointer = () =>
  window.matchMedia('(hover: hover) and (pointer: fine)').matches
